import BaseModel from './base';
import AdminEventTemplate from './admin-event-template';

export default class AdminEventTemplateTag extends BaseModel {
  constructor(tag, url) {
    super(tag, url);
    this.template = tag.template ? new AdminEventTemplate(tag.template, '') : null;
  }
}
